import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext();
const keyFor = (item) => `${item._id}:${(item.selectedOptions || []).map((option) => option.optionId).sort().join("-")}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("jummys_cart")) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("jummys_cart", JSON.stringify(items)); }, [items]);

  const addToCart = (menuItem) => {
    const cartKey = keyFor(menuItem);
    setItems((previous) => {
      const existing = previous.find((item) => item.cartKey === cartKey);
      if (existing) return previous.map((item) => item.cartKey === cartKey ? { ...item, quantity: item.quantity + (menuItem.quantity || 1) } : item);
      return [...previous, { ...menuItem, cartKey, quantity: menuItem.quantity || 1 }];
    });
  };
  const removeFromCart = (cartKey) => setItems((previous) => previous.filter((item) => item.cartKey !== cartKey));
  const updateQuantity = (cartKey, quantity) => setItems((previous) => previous.map((item) => item.cartKey === cartKey ? { ...item, quantity: Math.max(1, Number(quantity) || 1) } : item));
  const clearCart = () => setItems([]);
  const totalAmount = useMemo(() => items.reduce((sum, item) => sum + item.price * item.quantity, 0), [items]);
  return <CartContext.Provider value={{ items, addToCart, removeFromCart, updateQuantity, clearCart, totalAmount }}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
